import { useContext } from 'react';
import clsx from 'clsx';

import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import UserGroupIcon from '@atom/components/common/UserGroupIcon';
import AddTeamModalContext, {
  SelectedUserGroup,
} from '@atom/components/common/workOrderDetail/addTeamModal/AddTeamModalContext';
import { Icon } from '@atom/mui';
import { CloseIcon } from '@atom/mui/icons';
import { pluralize } from '@atom/utilities/stringUtilities';

import classes from './addTeamModal.module.css';

interface Props {
  userGroup: SelectedUserGroup;
}

const textOverflowWidth = '32rem';

const UserGroupCartTile = ({ userGroup }: Props) => {
  const { removeUserGroupFromCart } = useContext(AddTeamModalContext);

  const subtitle = `${userGroup?.userCount} ${pluralize(userGroup?.userCount, 'user')} • ${userGroup.groupPath.join(' / ')}`;

  return (
    <div className={classes.cartTileContainer}>
      <div className={classes.sideTileContainer}>
        <UserGroupIcon colorId={userGroup.colorId} />
        <div>
          <div className={classes.tileTitle}>
            <TextOverflowTooltip
              width={textOverflowWidth}
              text={userGroup.name}
              lightTooltip
            />
          </div>
          <div className={clsx(classes.tileSubtext, classes.path)}>
            <TextOverflowTooltip
              width={textOverflowWidth}
              text={subtitle}
              lightTooltip
            />
          </div>
        </div>
      </div>
      <div className={classes.sideTileContainer}>
        <Icon
          className={classes.closeIcon}
          onClick={() => removeUserGroupFromCart(userGroup.id)}
          icon={CloseIcon}
        />
      </div>
    </div>
  );
};

export default UserGroupCartTile;
